<template>
  <body>
    <div class="about-body">
      <img
        class="wecobi-image"
        src="../../../assets/wecobi2.png"
        alt="wecobi-image"
      />
      <img
        class="wecobi-image-mobile"
        src="../../../assets/Wecobi2mobile.png"
        alt="wecobi-image-mobile"
      />
      <div class="about-wrapper">
        <div class="images-wrapper">
          <div>
            <img
              class="image-one"
              src="../../../assets/Campaign.png"
              alt="image-one"
            />
          </div>
          <div>
            <img
              class="image-two"
              src="../../../assets/myaccount.png"
              alt="image-two"
            />
          </div>
        </div>
        <div class="text-wrapper">
          <div class="heading">
            <span class="title">Wecobi</span> is a free pre-order, co-buying
            platform that incentivizes a sharing culture and rewards loyal
            customers.
          </div>
          <div class="text">
            Allowing brands to offload excess inventory at discounted rates
            while preserving brand value and control. Wecobi ensures oversight
            and a secondary sales channel without compromising the integrity of
            the brands primary market.
          </div>
          <a href="/wecobi-pitch-deck.pdf" target="_blank" class="button"
            >More About App</a
          >
        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "About",
};
</script>

<style scoped>
.about-body {
  width: 100%;
  height: 932px;
  background: linear-gradient(0.25turn, #232323, 70%, #000000);
  border-radius: 20px;
  position: relative;
  display: flex;
  color: #ffffff;
  z-index: 0;
}
.wecobi-image {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px;
  z-index: 1;
  max-width: 50%;
}
.wecobi-image-mobile {
  display: none;
}
.about-wrapper {
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 87px;
}
.images-wrapper {
  display: flex;
  min-width: 425px;
  height: 560px;
  align-items: flex-end;
  position: relative;
}
.image-two {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
.text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 500px;
}
.title {
  font-size: 30px;
  color: #f98140;
  font-weight: 600;
}
.heading {
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
  line-height: 40px;
}
.text {
  font-size: 14px;
  font-weight: normal;
  color: #d4d4d4;
  line-height: 25px;
}
.button {
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  border: 2px solid #ffffff;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 193px;
  height: 50px;
}

.button:hover {
  color: #000000;
  border: 2px solid #ffffff;
  background-color: #ffffff;
}

@media (max-width: 1280px) {
  .about-body {
    height: 772px;
  }
}

@media (max-width: 1024px) {
  .about-body {
    height: fit-content;
    padding: 40px 30px 30px 30px;
    box-sizing: border-box;
  }
  .about-wrapper {
    gap: 40px;
  }
  .images-wrapper {
    min-width: 318px;
    display: flex;
    height: 400px;
    align-items: flex-end;
    position: relative;
  }
  .image-one {
    max-width: 170px;
  }
  .image-two {
    max-width: 170px;
  }

  .text-wrapper {
    max-width: 385px;
  }
  .heading,
  .title {
    font-size: 25px;
  }
}
@media (max-width: 744px) {
  .about-wrapper {
    gap: 20px;
  }
}

@media (max-width: 650px) {
  .about-body {
    height: 780px;
  }
  .wecobi-image {
    display: none;
  }
  .about-wrapper {
    z-index: 2;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .text-wrapper {
    max-width: 350px;
  }
  .title,
  .heading {
    font-size: 18px;
    line-height: normal;
  }
  .text {
    font-size: 14px;
    line-height: normal;
  }

  .button {
    max-width: 157px;
    height: 40px;
    font-size: 14px;
  }
  .wecobi-image-mobile {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 20px;
    max-width: 100%;
  }
}
</style>
